// extracted by mini-css-extract-plugin
export default {"noActiveCandidateModal":"NoLongerActiveCandidateModal_noActiveCandidateModal__gQ2ez","infoWrapper":"NoLongerActiveCandidateModal_infoWrapper__x6bJx"};